module.exports = __webpack_public_path__ + "img/ikuti-beragam.b10a060d.jpg";